// View text field and be edited. Field also has auto-expand feature.
/*
  Text Field accepts following parameters: 
  1) label (String) 
  2) value (String)
  3) fieldId (String) - works as ref/name.
  4) editMode (Boolean) - decides which mode to show initially (edit/view). If true, Save/Cancel is not available, onBlur event triggers save action.
  5) saveChanges (Function) - passed as prop from parent to this component and emitted whenever changes are saved. 
  6) userTyping (Function) - passed as prop from parent to this component and emitted whenever filed is in edit mode. 
  
  v-model works for this component to capture the value

 */
<template>
  <div class="flex flex-col p-2 flex-no-shrink flex-no-grow rounded-sm bg-white" style="width: 100%">
    <div class="flex justify-between w-full mb-2 flex-no-shrink flex-no-grow">
      <div class="flex mr-auto">
        <label class="text-sm font-semibold text-grey-dark tracking-wide" for="prescribe_drug" style="text-transform: uppercase">
          {{label}}
        </label>
      </div>
      <div class="flex ml-auto mr-1" v-if="!inEdit && canEdit" @click="edit()">
        <span class="justify-center cursor-pointer text-blue text-sm font-semibold">Edit</span>
      </div>
      <div class="flex ml-auto" v-if="inEdit">        
        <span v-if="!editMode || editMode === 'false'" @click="save()" class="justify-center cursor-pointer text-blue text-sm font-semibold">Save</span>
        <span v-if="!editMode || editMode === 'false'" @click="cancel()" class="pl-2 justify-center cursor-pointer text-grey-light text-sm font-semibold">Cancel</span>
      </div>
    </div>
    <div v-if="!inEdit">
      <p class="text-grey-darker text-m" v-html="text"></p>
    </div>
    <div v-else class="flex flex-row flex-no-shrink flex-no-grow relative">
      <div contenteditable="true" :id="'editor_'+fieldId" @input="onDivInput($event)" @blur="onBlurEvent()"
        class="p-2 pr-10 w-full relative bg-grey-extralight rounded-sm border border-solid border-grey-lightest text-base text-grey-darkest" 
        style="outline: none; overflow-y: auto; text-overflow: inherit; min-height: 2rem; line-height: 1.2" v-html="text">
      </div>
      <div class="h-8 w-8 absolute pin-r" style="margin-top: 2px;">
        <SpeechRecognition @getVoiceMessage="getVoiceMessage" :message="message" />
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import SpeechRecognition from '@/components/common/SpeechRecognition'
import {mapGetters} from 'vuex'
export default {
  components: {
    SpeechRecognition
  },
  props: ['value', 'label', 'fieldId', 'editMode', 'error'],
  data () {
    let inEdit = false
    if (this.editMode && this.editMode === 'true') {
      inEdit = true
    }
    return {
      inEdit: inEdit,
      text: this.value ? this.value : '',
      message: ''
    }
  },
  computed: {
    ...mapGetters({
      customer: 'configuration/getActivePatientProfile'
    }),
    canEdit: function () {
      if (this.customer) {
        if (this.customer.consultation.summary_status === 'done' || this.customer.consultation.summary_status === 'not_needed') {
          return false
        } else {
          return true
        }
      }
    }
  },
  watch: {
    value: function (val) {
      this.text = val
    },
    customer: function (newVal, oldVal) {
      if (newVal !== oldVal) {
        if (!this.value) {
          this.text = ''
          if (document.getElementById('editor_' + this.fieldId)) {
            document.getElementById('editor_' + this.fieldId).innerHTML = ''
          }
          return
        }
      }
    }
  },
  methods: {
    edit: function () {
      this.inEdit = true
      let that = this
      Vue.nextTick(function () {
        document.getElementById('editor_' + that.fieldId).innerHTML = that.text ? that.text : ''
      })
    },
    save: function () {
      if (this.error && this.error.hasError) {
        this.$toast.open({ message: this.error.message ? this.error.message : 'Something went wrong', type: 'error', position: 'top', queue: false })
        return
      }
      const checkText = document.getElementById('editor_' + this.fieldId).innerText
      if (!checkText.trim()) {
        this.$toast.open({
          message: this.label + ' cannot be empty',
          type: 'error',
          position: 'top',
          queue: false
        })
        return
      }
      this.text = document.getElementById('editor_' + this.fieldId).innerHTML
      this.inEdit = false
      this.$emit('saveChange', {[this.fieldId]: this.text})
      this.$store.dispatch('textField/updateTextFieldState', {inEdit: false, field: this.fieldId})
    },
    cancel: function () {
      this.inEdit = false
      this.$store.dispatch('textField/updateTextFieldState', {inEdit: false, field: this.fieldId})
    },
    onBlurEvent: function () {
      if (this.editMode) {
        this.text = document.getElementById('editor_' + this.fieldId).innerText
        this.$emit('saveChange', {[this.fieldId]: this.text})
        this.$store.dispatch('textField/updateTextFieldState', {inEdit: false, field: this.fieldId})
      }
    },
    onDivInput: function (e) {
      this.message = e.target.innerHTML
      this.$emit('input', e.target.innerHTML)
      this.$store.dispatch('textField/updateTextFieldState', {inEdit: true, field: this.fieldId})
    },
    getVoiceMessage: function (message) {
      this.message = message
      let that = this
      Vue.nextTick(function () {
        document.getElementById('editor_' + that.fieldId).innerHTML = message
      })
    }
  }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/common/TextField.vue